import { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./SapCapisquadraActions.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

const SapCapisquadraActions = () => {
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [lastUpload, setLastUpload] = useState(null);
    const [message, setMessage] = useState({ type: "", text: "" });
    const fileInputRef = useRef(null);

    const fetchLastUpload = async () => {
        try {
            const res = await axios.get(`${API_URL}/hera/lastUpload/servizi-cons-sap`);
            setLastUpload(res.data.lastUpload
                ? new Date(res.data.lastUpload).toLocaleString("it-IT")
                : null);
        } catch (err) {
            console.error("fetchLastUpload SAP:", err);
        }
    };

    useEffect(() => { fetchLastUpload(); }, []);

    const handleClickCarica = (e) => {
        e.stopPropagation();
        if (loading) return;
        fileInputRef.current?.click();
    };

    const handleFileSelected = async (e) => {
        e.stopPropagation();
        const file = e.target.files?.[0];
        if (!file) return;

        setLoading(true);
        setMessage({ type: "", text: "" });

        const formData = new FormData();
        formData.append("file", file);

        try {
            const res = await axios.post(`${API_URL}/hera/sap/servizi-cons`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            setMessage({ type: "success", text: res.data.message || "File caricato con successo" });
            await fetchLastUpload();
        } catch (err) {
            const data = err.response?.data;
            let text = data?.error || "Errore durante il caricamento del file";
            if (Array.isArray(data?.missingColumns) && data.missingColumns.length > 0) {
                text += ` Colonne mancanti: ${data.missingColumns.join(", ")}.`;
            }
            if (Array.isArray(data?.duplicati) && data.duplicati.length > 0) {
                const elenco = data.duplicati.slice(0, 10).map(d => `${d.servizio}/${d.data}`).join(", ");
                const extra = data.duplicati.length > 10 ? ` (e altri ${data.duplicati.length - 10})` : "";
                text += ` Righe duplicate (SERVIZIO/DATA): ${elenco}${extra}.`;
            }
            setMessage({ type: "error", text });
        } finally {
            setLoading(false);
            if (fileInputRef.current) fileInputRef.current.value = "";
        }
    };

    const handleScarica = async (e) => {
        e.stopPropagation();
        if (downloading) return;
        setDownloading(true);
        setMessage({ type: "", text: "" });
        try {
            const res = await axios.get(`${API_URL}/upload/download/servizi-cons-sap`, {
                responseType: "blob"
            });
            if (res.data.type === "application/json") {
                const text = await res.data.text();
                const errorData = JSON.parse(text);
                throw new Error(errorData.error || "Errore durante il download");
            }
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "servizi-cons-sap.xlsx");
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            const errMsg = err.response?.data?.error || err.message || "Errore durante il download";
            setMessage({ type: "error", text: errMsg });
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div className="sap-capisquadra-footer" onClick={(e) => e.stopPropagation()}>
            <div className="sap-capisquadra-last-upload">
                {lastUpload ? `Ultimo caricamento: ${lastUpload}` : "Nessun file caricato"}
            </div>
            <div className="sap-capisquadra-actions">
                <button
                    type="button"
                    className="sap-capisquadra-btn sap-capisquadra-btn-upload"
                    onClick={handleClickCarica}
                    disabled={loading}
                    title="Carica file Excel SAP servizi consuntivati"
                >
                    {loading ? "Carico..." : "Carica"}
                </button>
                <button
                    type="button"
                    className="sap-capisquadra-btn sap-capisquadra-btn-download"
                    onClick={handleScarica}
                    disabled={downloading}
                    title="Scarica l'ultimo file SAP caricato"
                >
                    {downloading ? "Scarico..." : "Scarica"}
                </button>
            </div>
            {message.text && (
                <div className={`sap-capisquadra-message ${message.type}`}>{message.text}</div>
            )}
            <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls,.csv"
                style={{ display: "none" }}
                onChange={handleFileSelected}
            />
        </div>
    );
};

export default SapCapisquadraActions;